/*
 * @Date: 2023-11-12 23:34:48
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2023-11-15 17:30:56
 * @FilePath: /nicee-web-tw/src/components/VoiceRoom/message.js
 * @Description: 語音房發送的消息類型
 */

const emojiResource = [
  {
    name: '剪刀石頭布',
    imageNameList: ['emoji_jiandao.webp', 'emoji_shitou.webp', 'emoji_bu.webp']
  },
  {
    name: '舉手',
    imageNameList: ['emoji_handup.webp']
  },
  {
    name: '亮燈',
    imageNameList: ['emoji_light.webp']
  },
  {
    name: '謝謝',
    imageNameList: ['emoji_thank.webp']
  },
  {
    name: '求禮物',
    imageNameList: ['emoji_gift.webp']
  },
  {
    name: 'OK',
    imageNameList: ['emoji_ok.webp']
  },
  {
    name: '哈哈',
    imageNameList: ['emoji_haha.webp']
  },
  {
    name: '親親',
    imageNameList: ['emoji_kiss.webp']
  },
  {
    name: '哭',
    imageNameList: ['emoji_cry.webp']
  },
  {
    name: '笑哭',
    imageNameList: ['emoji_laughcry.webp']
  },
  {
    name: '傻眼',
    imageNameList: ['emoji_....webp']
  },
  {
    name: '問號',
    imageNameList: ['emoji_?.webp']
  },
  {
    name: '舒服',
    imageNameList: ['emoji_comfortable.webp']
  },
  {
    name: '應援',
    imageNameList: ['emoji_cheer.webp']
  }
];
//文字類型消息
export class TextMessage {
  data = {
    version: '1',
    action: '301',
    command: {
      action: 'normal',
      level: '',
      nickName: ''
    },
    message: ''
  };
  description = '';
  extension = '';
  constructor(text, level, nickName) {
    this.data.message = text;
    this.data.command.level = level;
    this.data.command.nickName = nickName;
  }
}
/**
 * @description: 图片类型消息
 * @return {*}
 */
export class EmojiMessage {
  data = {
    version: '1',
    action: '301',
    command: 'emojiReceive',
    message: {
      imageUrlList: [],
      seatIndex: 0,
      avatar: '',
      uuid: '',
      nickName: '',
      level: '',
      animationUrlList: [],
      name: ''
    }
  };
  description = '';
  extension = '';

  constructor(uuid, nickName, avatar, emojiName, seatIndex) {
    console.log(uuid, nickName, avatar, emojiName, seatIndex);
    const emojiItem = emojiResource.find(item => {
      return item.name === emojiName;
    });
    let emojiList = emojiItem.imageNameList;
    if (emojiItem.name === '剪刀石頭布') {
      emojiList = shuffleArray([...emojiItem.imageNameList]);
    }
    this.data.message.uuid = uuid;
    this.data.message.nickName = nickName;
    this.data.message.avatar = avatar;
    this.data.message.animationUrlList = emojiList;
    this.data.message.imageUrlList = emojiList;
    this.data.message.seatIndex = seatIndex;
    this.data.message.name = emojiName;
    function shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    }
  }
}

export class ImageMessage {
  data = {
    version: '1',
    action: '301',
    message: {
      level: '',
      nickname: '',
      content: '',
      avatar: '',
      uuid: ''
    },
    command: 'imageReceive'
  };
  description = '';
  extension = '';
  constructor(uuid, url, level, nickName, avatar) {
    this.data.message.uuid = uuid;
    this.data.message.content = url;
    this.data.message.level = level;
    this.data.message.nickname = nickName;
    this.data.message.avatar = avatar;
  }
}
